import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M21.75 4A1.75 1.75 0 0 0 20 2.25h-9.994A1.75 1.75 0 0 0 8.256 4v2a.75.75 0 0 0 1.5 0V4a.25.25 0 0 1 .25-.25H20a.25.25 0 0 1 .25.25v16a.25.25 0 0 1-.25.25H10a.25.25 0 0 1-.25-.25v-2a.75.75 0 0 0-1.5 0v2c0 .966.784 1.75 1.75 1.75h10A1.75 1.75 0 0 0 21.75 20z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M11.47 7.47a.75.75 0 0 0 0 1.06L14.94 12l-3.47 3.47a.75.75 0 1 0 1.06 1.06l4-4a.75.75 0 0 0 0-1.06l-4-4a.75.75 0 0 0-1.06 0",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M16.25 11.996a.75.75 0 0 0-.75-.75H4a.75.75 0 0 0 0 1.5h11.5a.75.75 0 0 0 .75-.75",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }